<template>
    <div>
        <my-header></my-header>
        <div class="container">
            <img src="../../assets/img/home_bg.png" alt="" class="top">
            <div class="df content">
                <div class="df info">
                    <img :src="userInfo.Avatar" alt="">
                    <p>No.{{userInfo.JobNo}}</p>
                    <p class="ft20">{{userInfo.NickName}}</p>
                    <router-link tag="div" to="/share" class="share-btn" v-show="nowIndex!=4">我要分享</router-link>
                </div>
                <div class="df nav">
                    <router-link tag="div" to="/homepage/original?sourceType=2" @click.native="nowIndex=2" :class="{active: nowIndex==2}">原创作品分享</router-link> 
                    <router-link tag="div" to="/homepage/original?sourceType=1" @click.native="nowIndex=1" :class="{active: nowIndex==1}">图片素材</router-link> 
                    <router-link tag="div" to="/homepage/original?sourceType=3" @click.native="nowIndex=3" :class="{active: nowIndex==3}">ppt</router-link> 
                    <router-link tag="div" to="/homepage/collect" @click.native="nowIndex=4" :class="{active: nowIndex==4}">收藏</router-link>
                </div>
            </div>
            <router-view :userInfo="userInfo" @getNavIndex="getNavIndex"></router-view>
        </div>
        <my-footer></my-footer>
    </div>
</template>
<script>
export default {
  data(){
      return {
          userInfo: {
              Id: "",
              Avatar: "",   //头像
              JobNo: "182904",    //工号
              Name: "王某",     //姓名
              NickName: "", //昵称
          },
          nowIndex: 0,
      }
  },
  created(){
      let userInfo = JSON.parse(localStorage.getItem('userInfo'));
      Object.keys(this.userInfo).forEach((key)=>{
          if(userInfo.hasOwnProperty(key)){
              this.userInfo[key] = userInfo[key];
          }
      })
  },
  methods: {
      getNavIndex(index){
          this.nowIndex = index;
      }
  }
}
</script>
<style scoped>
.top{
    display: block;
    width: 100%;
}
.content{
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    background-color: #fff;
}
.info{
    flex-direction: column;
    justify-content: flex-start;
    padding-bottom: 30px;
    align-items: center;
}
.info img{
    width: 135px;
    height: 135px;
    background-color: #e7e7e7;
    border: 6px solid #fff;
    border-radius: 50%;
    margin-top: -78px;
}
.info p{
    margin-top: 10px;
}
.ft20{
    font-size: 20px;
}
.share-btn {
  width: 186px;
  line-height: 38px;
  height: 40px;
  border-radius: 20px;
  border: 1px solid #ff9933;
  box-sizing: border-box;
  margin-top: 20px;
  cursor: pointer;
}

.share-btn:hover {
  color: #fff;
  background-color: #ff9933;
}
.nav{
    width: 100%;
    justify-content: center;
    font-size: 18px;
    color: #333;
    height: 80px;
    line-height: 80px;
    border-top: 1px solid #e7e7e7;
    border-bottom: 1px solid #e7e7e7;
}
.nav div{
    padding: 0 15px;
    cursor: pointer;
    position: relative;
    margin-right: 15px;
}
.nav div:last-of-type{
    margin-right: 0;
}
.nav div::after{
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 4px;
    transform: scale(0,1);
    transition: transform 0.5s;
    content: "";
    background-color: #6699ff;
}
.nav .active::after{
    transform: scale(1,1);
}
</style>



// WEBPACK FOOTER //
// src/components/homePage/index.vue